<template>
  <!-- 投資型基本輸入：版型四　躉繳VA -->
  <div>
    <div class="row mt_16"><div class="col create_title" >規劃保費</div></div>
    <!-- 保費 -->
    <div class="form-group d-flex align-items-end mt_20">
      <!-- <div class="d-flex text-norwap mr_8">
        <strong style="line-height: 40px">規劃保費:</strong>
      </div> -->
      <div class="d-flex align-items-center mr_16">
        <!-- 繳別 -->
        <label><strong>繳別:</strong></label>
        <select
          class="form-control"
          style="width: 8rem"
          :id="'pay_freq'"
          data-vv-name="pay_freq"
          :class="{ 'is-invalid': errors.has('pay_freq') }"
          v-validate="`required`"
          data-vv-as="繳別"
          v-model="productDataScope.pay_freq"
          @change="productDataScope.premium && $validator.validate(`premium`)"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(payFreqOption, index) in option.payFreq_option"
            :key="index.paraval"
            :value="payFreqOption.paraval"
          >
            {{ payFreqOption.paradetlno }}
          </option>
        </select>
      </div>
      <!-- 保費 -->
      <div class="d-flex align-items-center mr_8">
        <div style="line-height: 40px" class="mr_4"><strong>保費:</strong></div>
        <div class="position-relative">
          <div
            class="notice-top text-red"
            v-if="PRODUCT_FEATURE_DATA.face_prem_incr_unit != '0'"
          >
            {{
              `需以${formatMethods(
                PRODUCT_FEATURE_DATA.face_prem_incr_unit
              )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
            }}
          </div>
          <div class="d-flex align-items-center">
            <input
              type="tel"
              class="form-control mr_2"
              style="width: 175px"
              :class="{ 'is-invalid': errors.has('premium') }"
              :id="'premium'"
              :data-vv-name="'premium'"
              v-validate="`required|premium`"
              data-vv-as="保費"
              @input="numberHandler(productDataScope, 'premium', $event)"
              @blur="numberHandler(productDataScope, 'premium', $event)"
              :value="productDataScope.premium | formatMethods"
              @change="productDataScope.amt && $validator.validate(`amt`)"
              :placeholder="
                productDataScope.pay_freq &&
                prem_limit[productDataScope.pay_freq]
                  ? `${formatMethods(
                      converIncrUnit(
                        prem_limit[productDataScope.pay_freq].prem_floor
                      )
                    )}~${formatMethods(
                      converIncrUnit(
                        prem_limit[productDataScope.pay_freq].prem_ceil
                      )
                    )}`
                  : ''
              "
            />
          </div>
        </div>
        <span>{{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import { Validator } from "vee-validate";
import moment from "moment";
export default {
  props: ["productDataScope", "mainIndex", "option"],
  mixins: [mf_Mixin],
  data() {
    return {
      amt_limit: null,
      prem_limit: [{}, {}, {}, {}],
      getINVPremiumLimitTimer: null,
      getINVAmtLimitTimer: null,
      yearPremiumLimit: null,
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productDataScope.FEATURE_DATA;
    },
    amt_formatVal() {
      if (this.productDataScope.FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.productDataScope.FEATURE_DATA.amt_unit);
      }
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.productDataScope.pol_endage_tmp = this.productDataScope.pol_endage;
      this.getINVLimitRanges();
    },
    async getINVLimitRanges() {
      let insured_actage = this.MfEditing.insured.insured_birthday
        ? moment().diff(
            moment(this.MfEditing.insured.insured_birthday),
            "years"
          )
        : this.MfEditing.insured.insured_age;
      let { amt_limit, prem_limit } =
        await this.$mfAPI.MFB1_0100__getINVLimitRanges({
          prod_id: this.nowProduct.prod_id,
          insured_actage: insured_actage,
          insured_age: this.MfEditing.insured.insured_age,
          insured_gender: this.MfEditing.insured.insured_gender,
        });
      this.amt_limit = amt_limit;
      this.prem_limit = prem_limit;
      this.initValidator();
    },
    async getINVPremiumLimitRanges() {
      if (this.getINVPremiumLimitTimer) {
        clearTimeout(this.getINVPremiumLimitTimer);
      }
      this.$store.commit("update_canSave", false);
      this.getINVPremiumLimitTimer = setTimeout(async () => {
        let vaild = await this.$validator.validate(`amt`);
        if (vaild) {
          let insured_actage = this.MfEditing.insured.insured_birthday
            ? moment().diff(
                moment(this.MfEditing.insured.insured_birthday),
                "years"
              )
            : this.MfEditing.insured.insured_age;
          let { prem_floor, prem_ceil } =
            await this.$mfAPI.MFB1_0100__getINVPremiumLimitRanges({
              prod_id: this.nowProduct.prod_id,
              insured_actage: insured_actage,
              insured_age: this.MfEditing.insured.insured_age,
              insured_gender: this.MfEditing.insured.insured_gender,
              amt: this.productDataScope.amt,
            });

          this.yearPremiumLimit = {
            prem_floor,
            prem_ceil,
          };
        } else {
          this.yearPremiumLimit = null;
          this.$store.commit("update_canSave", true);
        }
      }, 500);
    },
    initValidator() {
      Validator.extend(`premium`, {
        getMessage: "",
        validate: (value) => {
          if (!this.productDataScope.pay_freq) return false;
          let intValue = parseInt(value.split(",").join(""));
          //符合保費遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          let ceil =
            this.prem_limit[this.productDataScope.pay_freq].prem_ceil <= 0
              ? Infinity
              : this.prem_limit[this.productDataScope.pay_freq].prem_ceil;
          return (
            (!this.productDataScope.pay_freq ||
              (intValue <= ceil &&
                intValue >=
                  this.prem_limit[this.productDataScope.pay_freq]
                    .prem_floor)) &&
            intValue % incr_unit === 0
          );
        },
      });
    },
    converIncrUnit(number) {
      let face_prem_incr_unit =
        this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
          ? 1
          : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
      return Math.floor(number / face_prem_incr_unit) * face_prem_incr_unit;
    },
    async validateAll() {
      let VaildInput = await this.$validator.validateAll();
      return VaildInput;
    },
  },
  watch: {
    "productDataScope.amt": {
      handler() {
        if (!this.productDataScope.amt) return;
        this.getINVPremiumLimitRanges();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-right: 8px !important;
  line-height: 40px;
  white-space: nowrap;
}
.yearPremiumLimit {
  display: inline-block;
  padding: 5px 10px 4px;
  background-color: #fff3c2;
  font-weight: 700;
}
</style>
